import { AbstractControl, ValidatorFn } from '@angular/forms';

import { BookingFormGeneralErrorTypes } from '@app/entities/booking-form-general-error';

export function dateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean | string } | null => {
    const date = control?.value?.match(/\d+/g) || [];
    const isValid = isValidDate(
      Number(date?.[2]), Number(date?.[1]) - 1, Number(date?.[0])
    );
    return control?.value && !isValid ? {
      [BookingFormGeneralErrorTypes.INVALID_DATE]: true
    } : null;
  };
}

function isValidDate(year: number, month: number, day: number) {
  var d = new Date(year, month, day);
  if (d.getFullYear() === year && d.getMonth() === month && d.getDate() === day) {
    return true;
  }
  return false;
}
